export default __webpack_public_path__ + "static/nails_ladies-e7ca0d7c9368f912cbb705a9c0a35a02.jpg";